import React from "react"
import { CustomModal } from "./modal"
import { Formik } from 'formik';
import * as Yup from "yup"
import moment from "moment";
import { Button } from "./button";
import { useMutation } from "react-query";
import { addBalanceToExpert } from "../services/expert";

function SendMoneyModal({ expertId, onClose }) {
    const isOpen = Boolean(expertId)

    const { mutate, isLoading } = useMutation((data) => addBalanceToExpert(data), {
        onSuccess: () => {
            alert("Money has been sent successfully!")
            onClose()
        },
        onError: e => {
            alert(e.data?.message)
        }
    })

    const handleOnSubmit = (values, { setSubmitting }) => {
        //console.log({ amount: values.amount, expert_id: expertId })
        mutate({ amount: values.amount, expert_id: expertId })
        setSubmitting(false)
    }

    return (
        <CustomModal
            open={isOpen}
            onClose={onClose}
            className="commonCustomModal feedbackModal"
            body={expertId ? <Formik
                initialValues={{ amount: '' }}
                validationSchema={Yup.object().shape({
                    amount: Yup.number().required('Please specify the amount')
                })}
                onSubmit={handleOnSubmit}
            >
                {props => {
                    const {
                        values,
                        touched,
                        errors,
                        isSubmitting,
                        handleBlur,
                        handleChange,
                        handleSubmit,
                        setFieldValue
                    } = props
                    return (
                        <form onSubmit={handleSubmit}>
                            <h2 className="mb-20">
                                Send money to the expert
                            </h2>

                            <div className='mb-10'>
                                <h3 className='has-text-bold'>Amount in SAR*</h3>
                                <input
                                    type="number"
                                    name="amount"
                                    defaultValue={values.amount}
                                    className="stllr-input"
                                    onChange={(e) => (setFieldValue('amount', e.target.value))}
                                    onBlur={handleBlur}
                                />
                                {errors.amount && touched.amount && (
                                    <span className="v-error">{errors.amount}</span>
                                )}
                            </div>

                            <Button
                                text='Submit'
                                type='submit'
                                className='primary btn-lg mt-20'
                                disabled={isSubmitting || isLoading}
                            />
                        </form>
                    )
                }}
            </Formik> : "Loading.."}
        />
    )
}

export { SendMoneyModal }